
export enum DeployParamKind {
    asset = 'asset',
    localVarValue = 'localVarValue',
    location = 'location',
    sparkplugNodeCfg = 'sparkplugNodeCfg',
}
